/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _action_types = require('../../action_types');

var _helpers = require('./helpers');

function createPost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.CREATE_POST_REQUEST, _action_types.PostTypes.CREATE_POST_SUCCESS, _action_types.PostTypes.CREATE_POST_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function editPost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.EDIT_POST_REQUEST, _action_types.PostTypes.EDIT_POST_SUCCESS, _action_types.PostTypes.EDIT_POST_FAILURE, state, action);
}

function deletePost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.DELETE_POST_REQUEST, _action_types.PostTypes.DELETE_POST_SUCCESS, _action_types.PostTypes.DELETE_POST_FAILURE, state, action);
}

function getPostThread() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POST_THREAD_REQUEST, _action_types.PostTypes.GET_POST_THREAD_SUCCESS, _action_types.PostTypes.GET_POST_THREAD_FAILURE, state, action);
}

function getPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_REQUEST, _action_types.PostTypes.GET_POSTS_SUCCESS, _action_types.PostTypes.GET_POSTS_FAILURE, state, action);
}

function getPostsSince() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_SINCE_REQUEST, _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS, _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, state, action);
}

function getPostsBefore() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_BEFORE_REQUEST, _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS, _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, state, action);
}

function getPostsAfter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_AFTER_REQUEST, _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS, _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, state, action);
}

function reaction() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.REACTION_REQUEST, _action_types.PostTypes.REACTION_SUCCESS, _action_types.PostTypes.REACTION_FAILURE, state, action);
}

function openGraph() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.OPEN_GRAPH_REQUEST, _action_types.PostTypes.OPEN_GRAPH_SUCCESS, _action_types.PostTypes.OPEN_GRAPH_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    createPost: createPost,
    editPost: editPost,
    deletePost: deletePost,
    getPostThread: getPostThread,
    getPosts: getPosts,
    getPostsSince: getPostsSince,
    getPostsBefore: getPostsBefore,
    getPostsAfter: getPostsAfter,
    reaction: reaction,
    openGraph: openGraph
});



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/reducers/requests/posts.js
// module id = 1227
// module chunks = 60